import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styles: [],
    imports: [TranslatePipe]
})
export class ConfirmationModalComponent {
  activeModal = inject(BsModalRef);


  @Input() headerTitle;
  @Input() modalMessage;
  @Input() data: unknown;
  // @Input() submitFunction;
  @Output() public closeModalEvent = new EventEmitter();
  @Output() public submitFunction = new EventEmitter();

  modalRef: BsModalRef;
  modalOptions: ModalOptions = {
    // backdrop: 'static',
    keyboard: false,
    class: 'modal-lg',
  };


  closeModal(): void {
     this.activeModal.hide();
  }

  onSubmit(): void {
    this.closeModal();
    this.submitFunction.emit(this.data);
  }

}
